import MapIcon from '@mui/icons-material/Map';
import GoogleIcon from '@mui/icons-material/Google';
import SearchIcon from '@mui/icons-material/Search';
import {
  DialogContent,
  InputAdornment,
  Typography,
} from '@mui/material';
import { PointGeometry } from '@x-guard/xgac-types/xgac';
import { useState } from 'react';
import { useTranslate } from 'react-admin';
import { CustomConfirmDialog } from './CustomConfirmDialog';
import { StepDialogCard } from '../apps/bhvk/cards/stepDialogCard';
import { GoogleCoordinatesInput } from '../apps/bhvk/components/inputs/GoogleCoordinatesInput';

export const AddOverlayDialog = (props: {
  open: boolean;
  mapPlacementActive: boolean;
  onClose: () => void;
  onChooseMap: () => void;
  onConfirmAddress: (location: PointGeometry) => void;
}) => {

  const {
    open, mapPlacementActive, onClose, onChooseMap, onConfirmAddress,
  } = props;

  const translate = useTranslate();
  const [locationInputDialogOpen, setLocationInputDialogOpen] = useState(false);
  const [chosenLocation, setChosenLocation] = useState<PointGeometry | null>(null);

  const handleClose = () => {

    setLocationInputDialogOpen(false);
    setChosenLocation(null);
    onClose();

  };

  const chooserOpen = open && !mapPlacementActive && !locationInputDialogOpen;

  return (
    <>
      <CustomConfirmDialog
        open={chooserOpen}
        handleClose={handleClose}
        dialogTitle="resources.overlays.text.create_dialog_where_title"
        icon1={{
          title: 'resources.zones.text.create_dialog_where_map',
          subTitle: '',
          action: () => {

            onChooseMap();

          },
          icon: <MapIcon />,
        }}
        icon2={{
          title: 'resources.zones.text.create_dialog_where_input',
          subTitle: '',
          action: () => {

            setLocationInputDialogOpen(true);

          },
          icon: <GoogleIcon />,
        }}
      />
      <StepDialogCard
        title="resources.zones.text.create_dialog_where_input"
        open={locationInputDialogOpen}
        onClose={handleClose}
        onBack={() => {

          setLocationInputDialogOpen(false);
          setChosenLocation(null);

        }}
        onNext={() => {

          if (!chosenLocation) {

            return;

          }
          onConfirmAddress(chosenLocation);
          setLocationInputDialogOpen(false);
          setChosenLocation(null);

        }}
        nextLabel="ra.action.save"
        nextDisabled={!chosenLocation}
        content={
          <DialogContent>
            <Typography
              variant="body1"
              sx={{
                fontSize: '14px',
                marginBottom: '5px',
                fontWeight: 'bold',
              }}
            >
              {translate('general.fields.position.address.name')}
            </Typography>
            <GoogleCoordinatesInput
              className="bhvk-gray-input"
              value={chosenLocation}
              setValue={setChosenLocation}
              label={translate('resources.buttons.text.building_dialog.0.input_label')}
              variant="outlined"
              sx={{
                '& .MuiOutlinedInput-root': {
                  width: '100%',
                  height: '40px',
                },
                width: '60%',
              }}
              inputProps={{
                endAdornment: <InputAdornment position="end"><SearchIcon /></InputAdornment>,
              }}
              country={['nl', 'be', 'de']}
            />
          </DialogContent>
        }
      />
    </>
  );

};
